export default __webpack_public_path__ + "static/connect-illustration-26bd7d653e050bb4f49d8285ad793ab4.svg";